<template>
  <div class="card no-shadow m-l-12">
    <div class="card-content p-x-0 padding-top-0">
      <div class="additional-emails-section">

        <!-- additional email section -->
        <span>Additional email address</span>
        <ul v-if="additional_emails.length">
          <li v-for="(additionalEmail,index) in additional_emails">
            <strong>{{ additionalEmail.value }} </strong> |
            <a href="javascript:void(0);" @click.prevent="removeBusinessEmail(additionalEmail.field)">
              remove
            </a>
            <br/>
            <p v-if="additionalEmail.field === 'primary_email'">Added by a reviewer</p>
          </li>
        </ul>
        <ul v-if="!additional_emails.length">
          <li><strong>no email addresses added</strong></li>
        </ul>
      </div>
      <div v-if="!fetching_users" v-resultsCount="total_users"></div>

      <div class="content">
        <div class="level" v-if="!fetching_users">
          <table class="table is-size-7-touch is-marginless is-fullwidth transparent-table">
            <thead>
            <tr>
              <td class="pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey">First name</td>
              <td class="is-narrow-mobile is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey">Last name</td>
              <td class="is-narrow-mobile pad35-desktop is-desktop is-size-7-desktop has-text-weight-bold has-text-grey">Email address</td>
              <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Role</td>
              <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Last Login</td>
              <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Status</td>
              <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Linked Accounts</td>
            </tr>
            </thead>
            <tbody>
            <tr v-if="(fetching_users && users.length === 0) || (!fetching_users && users.length === 0)">
              <td class="is-narrow pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey" colspan="8">
                <p class="has-text-centered is-padded-20">No active users found</p>
              </td>
            </tr>
            <tr
              class="margin-bottom-20 clickable-row"
              v-for="(active_user, index) in users"
              v-if="users.length > 0"
              @click="gotoBizUserDetails(active_user)"
            >
              <td class="is-size-7-mobile is-size-7-touch has-text-weight-bold">{{active_user.first_name}}</td>
              <td class="is-narrow-mobile is-size-7-touch has-text-weight-bold">{{active_user.last_name}}</td>
              <td class="is-narrow-mobile is-desktop">{{active_user.email}}</td>

              <td class="is-narrow-mobile is-desktop" v-if="active_user.role === 'Business User'" :refs="active_user.invite_id">
                User
                <a class="color-2aabe1 is-size-7 has-text-underlined"
                   href="#"
                   @click.prevent="makeAdmin(active_user, $event)">MAKE ADMIN</a>
              </td>
              <td class="is-narrow-mobile is-desktop" v-else>Admin</td>

              <td class="is-narrow-mobile is-desktop">
                <span v-if="active_user.last_logged_in !== null">{{ prettyDate(active_user.last_logged_in) }}</span>
                <span v-else>Has never logged in</span>
              </td>
              <td class="is-narrow-mobile is-desktop">
                <span v-if="active_user.status === 'ACCEPTED'">Active</span>
                <span v-else-if="active_user.status === 'NEW'">Pending</span>
                <span v-else-if="active_user.status === 'SUSPENDED'">Suspended</span>
                <span v-else>Deleted</span>
              </td>
              <td class="is-narrow-mobile is-desktop">
                <a v-if="active_user.count_account_invite > 1" @click="getUserOtherProfiles(active_user.email, $event)">{{ active_user.count_account_invite }}</a>
                <span v-else>No</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import axios from 'axios'
  import moment from 'moment'
  import ApiResource from '../../api/ApiResource'

  export default {
    props: {
      businessName: {
        type: String
      }
    },
    data () {
      return {
        is_loading: true,
        fetching_users: false,
        total_users: 0,
        users: {},
        additional_emails: []
      }
    },
    computed: {
      getBusinessSlug () {
        return this.$router.currentRoute.params.slug
      }
    },
    created () {
      this.getUsers()
    },
    methods: {
      /**
       * Removes an email address from business profile
       *
       * @param {string} field to delete
       * @returns {void}
       */
      removeBusinessEmail (field) {
        new ApiResource({}).send(`/business/${this.getBusinessSlug}/delete-business-additional-email`, {field: field}, 'patch')
          .then(() => {
            flash('Additional email removed.')
            this.getUsers()
            dataLayer.push({
              'userMessage': {
                'messageType': 'success',
                'messageName': 'Successfully removed additional email in notification settings on Notifications View',
                'displayedMessage': 'Additional email address was removed successfully.'
              }
            })
          })
          .catch((error) => {
            console.log(error)
            flash(this.form.errors.getDefaultErrorMessage(), 'is-danger')
            dataLayer.push({
              'userMessage': {
                'messageType': 'error',
                'messageName': 'Failed to remove additional email in notification settings on Notifications View',
                'displayedMessage': 'Error removing additional email. Please try again later.'
              }
            })
          })
      },
      /**
       * Makes an api call to make business user a business admin
       * @param {object} activeUser invite record
       * @param {object} event event object
       * @returns {void}
       */
      makeAdmin (activeUser, event) {
        event.stopPropagation()
        axios.get(`/make-admin/${activeUser.invite_id}`)
          .then((response) => {
            activeUser.role = 'Business Admin'
            flash(response.data)
          })
          .catch((error) => {
            flash(error.error, 'is-danger')
          })
      },
      /**
       * Makes an api call to get list of all accepted users for org
       * @returns {void}
       */
      async getUsers () {
        this.users = {}
        this.fetching_users = true
        const activeUsersRequest = axios.get(`/business/${this.getBusinessSlug}/users?status=all`)
        const usersQuotaRequest = axios.get(`/${this.getBusinessSlug}/users-quota-for-subscription`)
        const [activeUsersResponse, usersQuotaRes] = await Promise.all([activeUsersRequest, usersQuotaRequest])
        try {
          this.users = activeUsersResponse.data
          this.fetching_users = false
          this.total_users = this.users.length
          this.additional_emails = usersQuotaRes.data.additional_emails
          window.document.title = `Business Portal | Hellopeter - ${this.businessName} (Users)`
          this.$gtm.trackEvent({
            event: 'pageLoad',
            virtualPageUrl: this.$router.currentRoute.path,
            virtualPageTitle: window.document.title
          })
        } catch (error) {
          this.fetching_users = false
        }
      },
      /**
       * get User's other business profiles
       * @param {string} email the email address of business user
       * @param {object} event event object
       * @return {void}
       */
      getUserOtherProfiles (email, event) {
        event.stopPropagation()
        axios.get(`/business/${email}/other-profiles/`)
          .then((response) => {
            let body = '<ul style="font-weight: normal;">'
            response.data.forEach((org) => {
              body += `<li><a target="_blank" href="/business/${org.business_slug}/billing">${org.business_name}</a> - ${org.role_name}</li>`
            })
            body += '</ul>'
            let options = {
              'title': '',
              'small_title': `<strong>${email}</strong> is also linked to these businesses`,
              'body': body,
              'show_btns': false
            }
            modal(options)
          })
          .catch(() => {
          })
      },
      prettyDate (date) {
        return moment(date).format('DD-MM-YYYY')
      },
      /**
       * Route to biz users details page
       * @param {Object} user User object
       * @return {void}
       */
      gotoBizUserDetails (user) {
        this.$router.push(`/bizuser-detail/${user.id}?back=${this.$route.path}`)
      }
    }
  }
</script>

<style scoped>
  .table td, .table th {
    border: none;
  }

  .table > tbody > tr {
    background-color: #f5f5f5 !important;
    margin-bottom: 10px;
  }

  .table > tbody > td {
    margin-bottom: 20px;
  }

  .clickable-row {
    cursor: pointer;
  }
  .additional-emails-section {
    display: flex;
    flex-direction: row;
    margin: 18px 0px 18px 0px;
  }
  .additional-emails-section > span {
    margin-right: 36px;
    font-size: 0.75rem !important;
  }
  .additional-emails-section > ul li {
    font-size: 0.75rem !important;
  }
  .additional-emails-section > ul li > p {
    margin: 3px 0px 5px 0px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/admin/BusinessUsers.vue